module.exports = __webpack_public_path__ + "static/img/battle_report2.e7d2987b.png";